import { Drawer, IconButton, Box, Stack } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { memo } from "react"
import CustomFilter from "../../../common/custom-filter/custom-filter"
import "./MobileFilterDrawer.scss"

const MobileFilterDrawer = memo(function MobileFilterDrawer({ isOpen, onClose, filters, currentFilterValues, managerView, onFilterChange }) {
  const handleLocalFilterChange = (filterKey, selectedOption) => {
    onFilterChange(filterKey, selectedOption)
    // Auto-close drawer after filter change
    setTimeout(() => {
      onClose()
    }, 200)
  }

  const filtersWithCurrentValues = filters.map((filter) => ({
    ...filter,
    filterValue: currentFilterValues?.[filter.filterKey] ?? filter.filterValue,
  }))

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      className="mobile-filter-drawer"
      sx={{
        "& .MuiDrawer-paper": {
          width: "280px",
          maxWidth: "85vw",
          backgroundColor: "background.default",
          color: "text.primary",
        },
      }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            padding: "16px",
            borderBottom: "1px solid",
            borderColor: "background.level2",
          }}
        >
          <Box component="h3" sx={{ margin: 0, fontSize: "16px", fontWeight: 500, color: "text.secondary" }}>
            Filters
          </Box>
          <IconButton
            onClick={onClose}
            sx={{
              color: "text.primary",
              "&:hover": {
                backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.1),
              },
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </IconButton>
        </Stack>

        {/* Filter List */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            padding: "16px",
          }}
        >
          <Stack spacing={0}>
            {filtersWithCurrentValues.map((filterData, filterIndex) => (
              <div key={`mobile-filter-${filterIndex}`} className="mobile-filter-item">
                <CustomFilter
                  filterData={filterData}
                  selectionChange={handleLocalFilterChange}
                  isAdmin={managerView}
                  wrapperClass="mobile-filter-wrapper"
                />
              </div>
            ))}
          </Stack>
        </Box>
      </Box>
    </Drawer>
  )
})

MobileFilterDrawer.displayName = "MobileFilterDrawer"

export default MobileFilterDrawer
